<template>
  <el-dialog
    :title="$t('114')"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    width="auto"
    class="holiday-rule-dialog"
  >
    <el-form :model="dataForm" ref="dataForm" :rules="dataRule" label-width="210px">
      <!-- 假期名称 英 中 泰 -->
      <el-form-item :label="$t('1159')" prop="name_en">
        <el-input v-model="dataForm.name_en" :placeholder="$t('90')" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item :label="$t('1157')" prop="name_zh">
        <el-input v-model="dataForm.name_zh" :placeholder="$t('90')" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item :label="$t('1158')" prop="name_th">
        <el-input v-model="dataForm.name_th" :placeholder="$t('90')" maxlength="100"></el-input>
      </el-form-item>
      <!-- 适用范围 -->
      <el-form-item :label="$t('1601')">
        <el-radio-group v-model="dataForm.is_all">
          <!-- 所有人 -->
          <el-radio label="1">{{ $t('998') }}</el-radio>
          <!-- 指定人员 -->
          <el-radio label="2">{{ $t('997') }}({{ dataForm.num || 0 }})</el-radio>
          <!-- 选择人员 -->
          <el-button type="text" @click="openEl" v-show="dataForm.is_all === '2'">{{ $t('633') }}</el-button>
        </el-radio-group>
      </el-form-item>
      <!-- 请假单位 -->
      <el-form-item :label="$t('1405')">
        <el-select v-model="dataForm.time_type" :placeholder="$t('1405')" @change="handlerShowRule">
          <el-option v-for="item in askLeave" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 请假时长核算 -->
      <el-form-item :label="$t('leave__ac_1')">
        <el-select v-model="dataForm.count_rule">
          <!-- 按自然日计算 -->
          <el-option :label="$t('leave__ac_2')" value="2"></el-option>
          <!-- 按工作日计算 -->
          <el-option :label="$t('leave__ac_3')" value="1"></el-option>
        </el-select>
        <p style="color: rgb(162 166 176)">{{ LeaveTip }}</p>
      </el-form-item>
      <!-- 折算规则 -->
      <el-form-item :label="$t('1440')" v-if="isShowConversionRateInput" prop="hour_to_day">
        <span>
          {{ $t('1406') }}
          <el-input-number
            style="width: 120px"
            v-model="dataForm.hour_to_day"
            :min="1"
            :max="24"
            :precision="2"
          ></el-input-number>
          {{ $t('1407') }}
        </span>
      </el-form-item>
      <!-- 新员工请假 -->
      <el-form-item :label="$t('1758')">
        <p>
          <el-checkbox v-model="dataForm.is_new_staff" @change="handleIsStaffStatus" />
          {{ $t('1666') }}
          <el-input-number
            style="width: 120px"
            v-model="dataForm.less_days"
            :disabled="!dataForm.is_new_staff"
            :min="0"
            :max="365"
          ></el-input-number>
          {{ $t('1667') }}
        </p>
        <p>
          <el-checkbox v-model="dataForm.is_probation" />
          {{ $t('1757') }}
        </p>
      </el-form-item>
      <!-- 计薪规则 -->
      <el-form-item :label="$t('1151')">
        <el-select v-model="dataForm.is_paid" :placeholder="$t('1145')">
          <el-option :label="item.label" :value="item.key" v-for="item in ruleList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <!-- 计薪天数 -->
      <el-form-item :label="$t('496')" v-if="dataForm.is_paid === '2'" prop="paid_days">
        <el-input-number v-model="dataForm.paid_days" :min="0.5" :step="0.5" step-strictly></el-input-number>
      </el-form-item>
      <!-- 余额设置 -->
      <el-form-item>
        <template slot="label">
          <span>{{ $t('1509') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('107')" placement="top-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-switch v-model="dataForm.my_is_setting" :disabled="isEdit"></el-switch>
      </el-form-item>
      <!-- 余额设置详情 -->
      <template v-if="dataForm.my_is_setting">
        <!-- 发放时间  -->
        <el-form-item :label="$t('1510')" class="release">
          <!-- dataForm.cycle
          cycle： 1 自然年(1月1日-12月31日) cycle 1
          cycle： 5 入职时间
          cycle： 3 仅发放一次
          cycle： 4 每满0.5天发放 且 rule: 2 司龄+自然年(页面展示的为司龄+自然年)
          -->
          <el-radio-group v-model="dataForm.cycle" @change="handleCycle" :disabled="isEdit">
            <el-radio v-for="item in settingCycleArr" :key="item.type" :label="item.type">{{ item.text }}</el-radio>
          </el-radio-group>
          <!-- 说明 -->
          <p class="quota-description" v-show="dataForm.cycle == 4">{{ $t('1624') }}</p>
          <!-- 每年**月**日发放 -->
          <div class="release_time" v-if="dataForm.cycle === 1">
            {{ $t('1511') }}
            <el-select
              v-model="dataForm.release_month"
              class="hire_time"
              @change="handleReleaseMont"
              :disabled="dataForm.cycle !== 1 || isEdit"
            >
              <el-option v-for="(item, index) in month" :key="index" :value="index" :label="item"></el-option>
            </el-select>
            <el-select
              v-model="dataForm.release_day"
              class="hire_time"
              @change="handleReleaseDay"
              :disabled="dataForm.cycle !== 1 || isEdit"
            >
              <el-option v-for="(item, index) in GetDays" :key="index" :value="index" :label="item"></el-option>
            </el-select>
            {{ $t('1514') }}
          </div>
          <p class="quota-description" v-if="dataForm.cycle === 3">{{ $t('1588') }}</p>
          <!-- 发放天数  -->
          <div class="rule_days" v-if="dataForm.cycle === 4">
            {{ $t('1514') }}
            <el-input-number
              v-model="dataForm.days"
              :min="dataForm.time_type != '1' ? 1 : 0.5"
              :step="dataForm.time_type != '1' ? 1 : 0.5"
              step-strictly
              controls-position="right"
            ></el-input-number>
            {{ askLeave1[dataForm.time_type] }}
            <span>
              {{ $t('1611') }}
              <!-- 最高额度 -->
              <!-- :max="dataForm.days" -->
              <el-input-number
                v-model="dataForm.max_days"
                :min="dataForm.time_type != '1' ? 1 : 0.5"
                :step="dataForm.time_type != '1' ? 1 : 0.5"
                step-strictly
                controls-position="right"
              ></el-input-number>
            </span>
          </div>
          <!-- 按照****等比例发放 -->
          <div v-if="dataForm.cycle === 1">
            {{ $t('holiday_rest_1') }}
            <el-select v-model="dataForm.is_hire" :disabled="isEdit" class="hire">
              <el-option :label="$t('holiday_rest_2')" value="3"></el-option>
              <el-option :label="$t('holiday_rest_3')" value="1"></el-option>
              <el-option :label="$t('holiday_rest_4')" value="2"></el-option>
              <el-option :label="$t('holiday_rest_5')" value="0"></el-option>
            </el-select>
          </div>
          <!--  -->
          <!-- <el-checkbox
            v-if="dataForm.cycle === 1"
            v-model="dataForm.my_is_hire"
            :label="dataForm.init_is_hire"
            :disabled="isEdit"
          >
            {{ $t('1515') }}
            <el-tooltip
              effect="dark"
              :content="dataForm.init_is_hire === '1' ? $t('120') : $t('1417')"
              placement="top-start"
            >
              <el-select v-model="dataForm.init_is_hire" :disabled="isEdit">
                <el-option :label="$t('1516')" value="1"></el-option>
                <el-option :label="$t('1517')" value="2"></el-option>
              </el-select>
            </el-tooltip>
            {{ $t('1518') }}
          </el-checkbox>-->
          <!-- 逐日发放 -->
          <div v-if="dataForm.cycle !== 4 && dataForm.cycle !== 3">
            <el-checkbox v-model="dataForm.my_release_type" :disabled="isEdit">{{ $t('1519') }}</el-checkbox>
          </div>
        </el-form-item>
        <!-- 假期发放规则
          rule: 2 司龄+自然年 且 cycle： 4 每满0.5天发放 假期发放规则不展示
          cycle: 3 仅发放一次 禁止选择按照司龄递增
          <el-radio label="1">固定额度</el-radio>
          <el-radio label="3" :disabled='dataForm.cycle === 3'>按照司龄递增</el-radio>
        -->
        <el-form-item :label="$t('1520')" class="rule" v-if="dataForm.cycle !== 4">
          <el-radio-group v-model="dataForm.rule" :disabled="isEdit">
            <el-radio
              v-for="item in QuotaRules"
              :key="item.value"
              :label="item.value"
              :disabled="item.value == '3' && dataForm.cycle === 3"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
          <el-form-item class="rule" prop="days">
            <!-- 发放***天 -->
            <div class="rule_days" v-if="dataForm.rule === '1'">
              {{ $t('1514') }}
              <el-input-number
                v-model="dataForm.days"
                :min="0"
                :max="maxDay"
                :precision="2"
                controls-position="right"
              ></el-input-number>
              {{ askLeave1[dataForm.time_type] }}
            </div>
          </el-form-item>
          <!-- 司龄< **年时，享有***天假 -->
          <div class="rule_incremental" v-if="dataForm.rule === '3'">
            <!-- 按照司龄递增展示内容 -->
            <div v-for="(item, ind) in dataForm.my_incremental_rule" :key="item.get" class="incremental_rule">
              <template v-if="dataForm.my_incremental_rule[ind + 1]">
                <template v-if="ind != 0">{{ $t('1587', { n: item.get }) }}≤</template>
                {{ $t('1532') }} {{ tag }}
                <el-input-number
                  style="width: 100px; margin: 0 10px 4px"
                  v-model="item.lt"
                  :max="incrementalMax(ind)"
                  :min="item.get + 1"
                  :step="1"
                  step-strictly
                  controls-position="right"
                  @change="reviseIncrementalRule('other', item, ind)"
                ></el-input-number>
              </template>
              <template v-else>
                {{ $t('1532') + ' ≥' }}
                <el-input-number
                  style="width: 100px; margin: 0 10px 4px"
                  v-model="item.get"
                  :step="1"
                  :min="dataForm.my_incremental_rule[ind - 1].get + 1"
                  step-strictly
                  controls-position="right"
                  @change="reviseIncrementalRule('last', item, ind)"
                ></el-input-number>
              </template>
              {{ $t('1533') }}
              <el-input-number
                style="width: 100px; margin: 0 10px 4px"
                v-model="item.days"
                :step="dataForm.time_type != '1' ? 1 : 0.5"
                :min="1"
                step-strictly
                controls-position="right"
              ></el-input-number>
              {{ askLeave1[dataForm.time_type] }}
              <i
                class="el-icon-delete"
                v-if="ind !== 0 && ind !== dataForm.my_incremental_rule.length - 1"
                @click="deleteIncrementalRule(item, ind)"
              ></i>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="addIncrementalRule">{{ $t('1531') }}</el-button>
          </div>
        </el-form-item>
        <!-- 有效期 -->
        <el-form-item :label="$t('124')">
          <el-radio-group v-model="dataForm.expire_time" :disabled="isEdit">
            <el-radio label="1" :disabled="dataForm.cycle === 3">{{ $t('1525') }}</el-radio>
            <el-radio label="2" :disabled="dataForm.cycle !== 3">{{ $t('1530') }}</el-radio>
          </el-radio-group>
          <!-- 允许最多**天假期，延长**个月 -->
          <div v-if="dataForm.expire_time == 1">
            {{ $t('1526') }}
            <el-input-number
              style="width: 100px; margin: 0 10px"
              v-model="dataForm.prolong_days"
              controls-position="right"
              step-strictly
              :min="0"
              :step="1"
              :max="365"
            ></el-input-number>
            {{ $t('1527') }}，{{ $t('1528') }}
            <el-input-number
              style="width: 100px; margin: 0 10px"
              v-model="dataForm.prolong"
              controls-position="right"
              step-strictly
              :min="0"
              :step="1"
              :max="12"
            ></el-input-number>
            {{ $t('1529') }}
          </div>
        </el-form-item>
      </template>
      <!-- 备注 -->
      <el-form-item :label="$t('1602')">
        <el-input type="textarea" v-model="dataForm.mark"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">{{ $t('131') }}</el-button>
    </template>
    <!-- 人员选择 -->
    <Org
      v-if="orgVisible"
      :visible.sync="orgVisible"
      @onConfirm="handlerSelected"
      :defaultDepatment="dataForm.deps"
      :defaultEmployess="dataForm.staffs"
      isRegister="1"
    />
  </el-dialog>
</template>

<script>
import { countStaffs } from 'api/Attendance'
import { ruleInfoListFn, ruleAddFn, ruleEditFn, getSettingCycleFn, showConversionRateInput } from 'api/approval/config'
import Org from '@/components/organization'
const dedaultDataForm = {
  is_all: '1', // 适用范围 1，2
  less_days: 0, // 新员工请假入职时间不能小于
  staff_ids: [], // 人员列表
  staffs: [], // 员工组
  mark: '', // 备注
  department_ids: [], // 部门列表
  deps: [], // 部门组
  id: null,
  name_en: '', // 假期名称（英文）
  name_zh: '', // 假期名称（中文）
  name_th: '', // 假期名称（泰文）
  is_setting: false, // 是否配置余额 余额设置
  my_is_setting: false,
  is_hire: '3', // 是否按入职时间 比例 分配额度, 等比例发放默认为3，全额发放
  release_type: null, // 逐日发放
  my_release_type: false, // 逐日发放复选框
  expire_time: '1', // 有效期
  days: 7, // 发放天数
  max_days: 7, // 最大天数
  rule: '1', // typeof string
  is_paid: '1', // 计薪规则
  paid_days: null, // 部分计薪天数
  prolong: null, // 延长有效期 单位月 如果没有 传0
  prolong_days: null, // 延长有效期 单位天 如果没有 传0
  cycle: 1, // 默认 一年发放, typeof number
  is_new_staff: false, // 新员工（勾选框）
  is_probation: false, // 通过试用期（勾选框）
  hour_to_day: 8, // 小时转天数计算单位/当time_type=0 ,必须存在
  time_type: '2', // 请假单位 0小时 1半天 2全天
  release_time: '01-01', // 每年发放时间
  release_month: 0, // 每年发放时间--月 需为number类型
  release_day: 0, // 每年发放时间--日 需为number类型
  my_incremental_rule: [
    { get: 0, lt: 1, days: null },
    { get: 1, lt: null, days: null }
  ],
  incremental_rule: '', // 司龄递增规则
  count_rule: '1' // 请假时长核算
}

// 额度规则选项
const QuotaRules = $t => [
  { label: $t('1632'), value: '1' },
  // { label: $t('1639'), value: '2' },
  { label: $t('1521'), value: '3' }
]
// 请假单位
const askLeave = $t => [
  { label: $t('1477'), value: '0' },
  { label: $t('1478'), value: '1' },
  { label: $t('1479'), value: '2' }
]
// 发放天数单位
const askLeave1 = $t => [$t('1523'), $t('1522'), $t('1522')]
// 选择月份和日
const month = $t => Array.from({ length: 12 }, (_, index) => index).map(item => $t(1538 + item + ''))
const days = $t => Array.from({ length: 31 }, (_, index) => index).map(item => $t(1550 + item + ''))
export default {
  components: {
    Org
  },
  data() {
    return {
      isShowConversionRateInput: false,
      tag: '<',
      visible: false,
      disabled: false,
      orgVisible: false,
      dataForm: dedaultDataForm,
      originalDataForm: {},
      // 额度规则
      QuotaRules: QuotaRules(this.$t),
      askLeave: askLeave(this.$t),
      askLeave1: askLeave1(this.$t),
      month: month(this.$t),
      days: days(this.$t),
      // 不带薪
      // 带薪
      // 部分带薪
      ruleList: [
        { key: '0', label: this.$t('1665') },
        { key: '1', label: this.$t('1669') },
        { key: '2', label: this.$t('1670') }
      ],
      dataRule: {
        name_en: [{ required: true, message: this.$t('90') }],
        days: [
          {
            validator: (rule, value, callback) => {
              value = Number(value)
              if (value === 0) {
                return callback(new Error(this.$t('1810')))
              }
              if (!value) {
                return callback(new Error(this.$t('1716')))
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        time_type: [{ required: true, message: this.$t('90') }],
        paid_days: [
          {
            validator: (rule, value, callback) => {
              value = Number(value)
              if (value === 0) {
                return callback(new Error(this.$t('1673')))
              }
              if (this.dataForm.is_paid !== null && !value) {
                return callback(new Error(this.$t('1671')))
              }
              if (value <= 0) {
                return callback(new Error(this.$t('1673')))
              }
              callback()
            },
            tigger: 'blur'
          }
        ],
        hour_to_day: [{ required: true, message: this.$t('1716'), trigger: 'blur' }]
      },
      isEdit: false,
      settingCycleArr: []
    }
  },
  computed: {
    maxDay() {
      if (this.dataForm.time_type === '0') return 8784
      return 366
    },
    // 额度规则联动发放方式
    CycleArr() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataForm.rule === '1' ? this.settingCycleArr.slice(0, 2) : this.settingCycleArr.slice(-1)
    },
    GetDays() {
      const dateTime = new Date()
      const year = dateTime.getFullYear()
      const month = this.dataForm.release_month + 1
      const date = new Date(year, month, 1)
      const days = new Date(date.getTime() - 864e5).getDate()
      const newDays = this.days.slice(0, days)
      return newDays
    },
    LeaveTip() {
      const tips = new Map([
        // 按自然日计算：选中后下方灰色文字提示“请假时段中若包含休息日，也会计入请假天数”；
        ['2', this.$t('leave_tip2')],
        // 按工作日计算：选中后下方灰色文字提示“请假时段默认去除休息日，例如周末、法定节假日”
        ['1', this.$t('leave_tip1')]
      ])
      return tips.get(this.dataForm.count_rule)
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$refs.dataForm.resetFields()
      }
    }
  },
  methods: {
    // 是否展示假期余额折算规则
    async handlerShowRule() {
      const { id, time_type } = this.dataForm
      if (this.dataForm.days > this.maxDay) this.dataForm.days = this.maxDay
      // 编辑状态下才展示
      if (this.isEdit) {
        const res = await showConversionRateInput({ id, time_type })
        this.isShowConversionRateInput = res.data
        return false
      }
      this.isShowConversionRateInput = time_type === '0'
    },
    // 勾选状态变化
    handleIsStaffStatus(val) {
      if (!val) {
        this.dataForm.less_days = 0
      }
    },
    init(item) {
      this.dataForm.max_days = this.dataForm.days
      this.visible = true
      this.getSettingCycleFn()
      if (item) {
        this.getInfo(item)
        this.isEdit = true
      } else {
        this.$nextTick(async () => {
          this.isEdit = false
          this.originalDataForm = JSON.parse(JSON.stringify(dedaultDataForm))
          this.dataForm = JSON.parse(JSON.stringify(dedaultDataForm))
          this.$nextTick(() => this.$refs.dataForm.clearValidate())
          this.$nextTick(() =>
            // 是否展示员工假期折算规则
            this.handlerShowRule()
          )
        })
      }
    },
    // 打开人员选择
    openEl() {
      this.orgVisible = true
    },
    // 最大天数 不能大于发放天数
    handlerChangeMaxDays(v) {
      if (Number(this.dataForm.max_days) > Number(v)) this.dataForm.max_days = v
    },
    // 人员选择回调
    handlerSelected(params) {
      this.dataForm.staffs = params.staff_list
      this.dataForm.deps = params.dept_list
      this.dataForm.staff_ids = params.staffIds
      this.dataForm.department_ids = params.depIds
      this.getSelectNum(params)
    },
    // 回显去重之后的人数
    getSelectNum({ depIds = [], staffIds = [] }) {
      countStaffs({ department_ids: depIds, staff_ids: staffIds }).then(res => {
        this.dataForm.num = res.data.staff_num
        this.$forceUpdate()
      })
    },
    // 获取发放时间筛选项
    async getSettingCycleFn() {
      const res = await getSettingCycleFn()
      if (res && res.code === 1) this.settingCycleArr = res.data
    },
    async getInfo(item) {
      const res = await ruleInfoListFn({ id: item.id })
      if (res && res.code === 1) {
        const data = res.data
        data.my_is_setting = Boolean(Number(data.is_setting))
        data.cycle = Number(data.cycle)
        data.my_release_type = data.release_type === '2'
        data.release_month = 0
        data.release_day = 0
        data.release_time = data.release_time || '01-01'
        data.my_incremental_rule = data.incremental_rule || [
          { get: 0, lt: 1, days: null },
          { get: 1, lt: null, days: null }
        ]
        const staffs = []
        if (Array.isArray(data.staff_ids)) {
          data.staff_ids.forEach(item => {
            staffs.push({
              staff_id: item.staff_id,
              staff_name: item.staff_name,
              staff_name_en: item.staff_name_en,
              staff_name_secondary: item.staff_name_secondary,
              staff_name_th: item.staff_name_th,
              avatar_url: item.avatar_url
            })
            this.dataForm.staff_ids.push(item.staff_id)
          })
        }
        this.dataForm = data
        this.originalDataForm = JSON.parse(JSON.stringify(data))
        this.handleReleaseTime(data.release_time)
        this.dataForm.staffs = staffs
        this.dataForm.deps = this.dataForm.department_ids
        if (Array.isArray(this.dataForm.department_ids)) {
          this.dataForm.department_ids = this.dataForm.department_ids.map(item => item.department_id)
        }
        this.$nextTick(() =>
          // 是否展示员工假期折算规则
          this.handlerShowRule()
        )
      }
    },
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          const { name_en } = this.dataForm
          if (!this.dataForm.name_zh) this.dataForm.name_zh = name_en
          if (!this.dataForm.name_th) this.dataForm.name_th = name_en
          this.dataFormFn()
            .then(res => {
              this.disabled = false
              if (res && res.code === 1) {
                this.visible = false
                this.$message.success(res.message || 'success')
                this.$emit('getTableList')
              }
            })
            .catch(() => {
              this.disabled = false
            })
        }
      })
    },
    dataFormFn() {
      const staff_ids = this.dataForm.staff_ids.map(item => {
        return item.staff_id || item
      })
      let res = null
      this.dataForm.max_days = Number(this.dataForm.max_days)
      if (this.dataForm.max_days < Number(this.dataForm.days)) this.dataForm.max_days = Number(this.dataForm.days)
      if (this.isEdit) {
        res = ruleEditFn({
          ...this.dataForm,
          staff_ids,
          id: this.dataForm.id,
          name: this.dataForm.name,
          days: this.dataForm.days,
          cycle: this.dataForm.cycle
        })
      } else {
        res = ruleAddFn({
          ...this.dataForm,
          staff_ids,
          name: this.dataForm.name,
          days: this.dataForm.days,
          is_setting: Number(this.dataForm.my_is_setting) + '',
          release_type: this.dataForm.my_release_type ? '2' : '1',
          incremental_rule: this.dataForm.rule === '1' ? '' : this.dataForm.my_incremental_rule,
          cycle: this.dataForm.cycle
        })
      }
      return res
    },
    //  release_time 字段为12-01， 处理数据，单独拿出月日
    handleReleaseTime(data) {
      const time = data.split('-')
      const month = time[0].replace(/\b(0+)/gi, '')
      const day = time[1].replace(/\b(0+)/gi, '')
      this.dataForm.release_month = Number(month) - 1
      this.dataForm.release_day = Number(day) - 1
    },
    // 发放时间切换，里面内容默认初始数据
    handleCycle(item) {
      // (item/data.cycle) typeof 为number
      const data = this.dataForm
      const original = this.originalDataForm // 深度拷贝的初始数据(未修改的数据)
      data.my_release_type = null
      data.expire_time = '1'
      data.is_hire = original.is_hire
      data.rule = original.rule
      if (item === 3) {
        // item == (data.cycle == 3)时，为仅发放一次， release_time要默认为01-01，为禁止选择状态
        data.release_time = '01-01'
        data.release_month = 0
        data.release_day = 0
        data.expire_time = '2'
        data.rule = '1'
      } else {
        data.release_time = original.release_time
        this.handleReleaseTime(original.release_time)
      }
      if (item === 4) {
        // item == (data.cycle == 4)时，为额度满0.5天时发放一次， rule === 2 为司龄+ 自然年
        data.rule = '2'
      }
    },
    // 处理发放时间月份
    handleReleaseMont(item) {
      this.dataForm.release_month = item
      const month = this.dataForm.release_month + 1
      const day = this.dataForm.release_day + 1
      const release_time = `${month < 10 ? 0 : ''}${month}-${day < 10 ? 0 : ''}${day}`
      this.dataForm.release_time = release_time
    },
    // 处理发放时间日期
    handleReleaseDay(item) {
      this.dataForm.release_day = item
      const month = this.dataForm.release_month + 1
      const day = this.dataForm.release_day + 1
      const release_time = `${month < 10 ? 0 : ''}${month}-${day < 10 ? 0 : ''}${day}`
      this.dataForm.release_time = release_time
    },
    // 司龄递增除第一个和最后一个以外
    reviseIncrementalRule(type, item, ind) {
      const incremental = this.dataForm.my_incremental_rule
      const len = incremental.length
      // 当前操作的上一个
      const prev = incremental[ind - 1]
      // 当前操作的下一个
      const next = incremental[ind + 1]
      if (len > 2) {
        if (type === 'last') {
          // 如果修改的是最后一个，将前一个的lt与最后一个get相等
          prev.lt = item.get
        } else {
          // 除最后一个以外，上一个的get与当前lt相等
          next.get = item.lt
        }
      } else {
        next ? (next.get = item.lt) : (prev.lt = item.get)
      }
    },
    // 添加司龄递增规则
    addIncrementalRule() {
      const incremental = this.dataForm.my_incremental_rule
      const len = incremental.length
      // 获取最后一个值
      const last = incremental[len - 1]
      // 获取倒数第二个值
      const last2 = incremental[len - 2]
      const status = last.get === last2.lt
      const data = [
        {
          get: last2.lt,
          lt: len <= 2 && !status ? last.get : last.get + 1, // 只有两条数据的话，当前只有两条数据且最后一条数据get不为1的情况下+1，否则相等
          days: ''
        },
        {
          get: len <= 2 && !status ? last.get : last.get + 1, // 同上
          lt: null,
          days: ''
        }
      ]
      incremental.splice(len - 1, 1, ...data)
    },
    // 删除司龄递增规则
    deleteIncrementalRule(item, index) {
      const incremental = this.dataForm.my_incremental_rule
      const len = incremental.length
      const prev = incremental[index - 1]
      const next = incremental[index + 1]
      if (len > 3) {
        if (index === len - 2) {
          // 删除的是倒数第二个数据，要将上一个的lt与最后一个的get相等
          prev.lt = incremental[len - 1].get
        } else {
          // 不是倒数第二条数据，可以直接将当前数据的上一条数据get与当前数据下一条lt相等
          next.get = prev.lt
        }
      } else {
        prev.lt = next.get
      }
      incremental.splice(index, 1)
    },
    incrementalMax(index) {
      const next = this.dataForm.my_incremental_rule[index + 1]
      const max = next && next.lt ? next.lt - 1 : Infinity
      return max
    }
  }
}
</script>

<style lang="scss" scoped>
.holiday-rule-dialog {
  /deep/ .el-dialog {
    max-width: 1000px;
  }
}

.quota-description {
  font-size: 12px;
  margin-top: 5px;
  text-align: justify;
  color: rgba($textColor, 0.5);
}
.holiday-rule-dialog {
  /deep/ .el-dialog__body {
    padding-right: 40px;
  }
  /deep/ .el-input-number--mini {
    width: 200px;
  }
}

// /deep/ .my_is_hire {
//   display: flex;
//   flex-direction: column;
//   .el-radio {
//     display: flex;
//     margin-top: 15px;
//   }
// }
.release {
  .hire_time {
    width: 130px;
    margin: 0 4px 4px 4px;
    input {
      padding-left: 5px;
    }
  }
  .hire_type {
    width: 110px;
    input {
      padding-left: 5px;
    }
    &__avtive {
      input {
        color: #5D51DA;
      }
    }
  }
}
.rule {
  &_days {
    .el-input-number {
      width: 120px;
    }
  }
  &_incremental {
    .el-icon-delete {
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
}
.hire {
  min-width: 500px;
  /deep/ .el-input {
    min-width: 500px;
  }
}
</style>
